import React from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';

export default function CerpaniForm(props) {
  const {
    six,
    nine,
    twelve,
    eighteen,
    twentyfour,
    noIdea,
    onChecked,
  } = props;

  return (
    <React.Fragment>
      <p>Předpokládané období čerpání:</p>
      <FormGroup style={{ flexDirection: 'row', justifyContent: 'space-around' }}>
        <FormControlLabel
          control={(
            <Checkbox
              checked={six}
              onChange={onChecked('six')}
              value='6'
            />
          )}
          label='6 měsíců'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={nine}
              onChange={onChecked('nine')}
              value='9'
            />
          )}
          label='9 měsíců'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={twelve}
              onChange={onChecked('twelve')}
              value='12'
            />
          )}
          label='12 měsíců'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={eighteen}
              onChange={onChecked('eighteen')}
              value='18'
            />
          )}
          label='18 měsíců'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={twentyfour}
              onChange={onChecked('twentyfour')}
              value='24'
            />
          )}
          label='24 měsíců'
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={noIdea}
              onChange={onChecked('noIdea')}
              value='noIdea'
            />
          )}
          label='Zatím nemáme představu'
        />
      </FormGroup>
    </React.Fragment>
  );
}

CerpaniForm.propTypes = {
  eighteen: PropTypes.bool.isRequired,
  nine: PropTypes.bool.isRequired,
  noIdea: PropTypes.bool.isRequired,
  onChecked: PropTypes.func.isRequired,
  six: PropTypes.bool.isRequired,
  twelve: PropTypes.bool.isRequired,
  twentyfour: PropTypes.bool.isRequired,
};
